import { t } from 'i18next';

import { CustomerExternalNumberSourceType, CustomerExternalNumberType } from 'customer/enums';
import { ICustomerExternalNumber } from 'customer/types';

export const getExternalCustomerNumberLabel = (option: ICustomerExternalNumber) => {
  const { externalCustomerNumber, label, source } = option;

  if (!externalCustomerNumber) {
    return '';
  }

  let prefix = '';
  switch (source) {
    case CustomerExternalNumberSourceType.CUSTOMER:
      prefix = t('labelCompany');
      break;
    case CustomerExternalNumberSourceType.BOM:
      prefix = t('labelJob');
      break;
    case CustomerExternalNumberSourceType.LOCATION:
      prefix = label;
      break;
    default:
      prefix = null;
      break;
  }

  if (!prefix) {
    return externalCustomerNumber;
  }

  return t('labelExternalCustomerNumber', {
    customerNumber: externalCustomerNumber,
    prefix,
  });
};

/*
 * Get the list of external customer number types that are not already saved as a customer number,
 * in order to create a new customer number if choosen.
 * If all external customer number types are already saved as a customer number, return empty array.
 */
export const getExternalCustomerNumberTypeChoices = (
  options: ICustomerExternalNumber[]
): { value: CustomerExternalNumberType; label?: string }[] => {
  const sourceTypes = options.map(
    (option) => option.source as unknown as CustomerExternalNumberType
  );

  const choices = [
    {
      value: CustomerExternalNumberType.CUSTOMER,
      label: t('labelSaveAsCustomerNumber', { typeLabel: t('labelCompany') }),
    },
    {
      value: CustomerExternalNumberType.LOCATION,
      label: t('labelSaveAsCustomerNumber', { typeLabel: t('labelLocation') }),
    },
    {
      value: CustomerExternalNumberType.BOM,
      label: t('labelSaveAsCustomerNumber', { typeLabel: t('labelJob') }),
    },
  ];

  const filteredChoices = choices.filter((choice) => !sourceTypes.includes(choice.value));

  if (filteredChoices.length === 0) {
    return [];
  }

  filteredChoices.unshift({
    value: CustomerExternalNumberType.ORDER,
    label: t('labelUseForThisOrderOnly'),
  });

  return filteredChoices;
};
